export default "__VITE_ASSET__CEqPxNmi__"